import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";

function Lookup({ isOpen, onClose, onSelect ,lookupConfig,inputValue }) {
  const [query, setQuery] = useState(inputValue || "");
  const [results, setResults] = useState([]);
   const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && lookupConfig) {
      fetchResults(lookupConfig);
    }
  }, [isOpen, lookupConfig]);

  const fetchResults = async (lookupConfig) => {
        try {
        setLoading(true);
        const response = await axiosInstance.post("/search",lookupConfig);
        setResults(response.data);
        } catch (err) {
        alert("Failed to load Results,Please retry");
        } finally {
            setLoading(false);
        }
    };

  const handleSelect = (item) => {
    onSelect(item); // return selected row back to parent
    onClose();
  };


  const handleSearch = () => {
    fetch(`/api/search?query=${query}`)
      .then((res) => res.json())
      .then((data) => setResults(data));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
        {loading && <Loader />}
      <div className="bg-white rounded shadow-lg p-6 w-96">
        <h2 className="text-lg font-semibold mb-4">Search Results</h2>

        {/* Search field */}
        <div className="flex items-center border rounded px-2 py-1 mb-4">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="flex-grow px-2 py-1 focus:outline-none"
            placeholder="Search..."
          />
          <button
            onClick={handleSearch}
            className="text-gray-500 hover:text-blue-600"
          >
            <FaSearch />
          </button>
        </div>

        {/* Results list */}
        <div className="max-h-60 overflow-y-auto border rounded">
          {results.length === 0 ? (
            <div className="px-4 py-2 text-gray-500">No results</div>
          ) : (
            results.map((item) => (
              <div
                key={item.id}
                onClick={() => handleSelect(item)}
                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
              >
                {item.name}
              </div>
            ))
          )}
        </div>

        {/* Close button */}
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default Lookup;